import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '@/components/ui/navigation';
import Hero from '@/components/sections/Hero';
import CompanyIntro from '@/components/sections/CompanyIntro';
import PropertyTeaser from '@/components/sections/PropertyTeaser';
import ProjectsTeaser from '@/components/sections/ProjectsTeaser';
import ContactBanner from '@/components/sections/ContactBanner';
import Footer from '@/components/ui/footer';
import SEOHead from '@/components/SEOHead';
import PageSEO from '@/components/PageSEO';

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for password reset or email confirmation in URL
    const urlParams = new URLSearchParams(window.location.search);
    const fragment = window.location.hash;
    
    if (urlParams.has('type') || fragment.includes('type=recovery') || fragment.includes('type=signup')) {
      // Redirect to admin page to handle auth flow
      navigate('/admin');
    }
  }, [navigate]);
  return (
    <div className="min-h-screen bg-background">
      <SEOHead />
      <PageSEO 
        pageSlug="home" 
        fallbackTitle="Croostenburght Beheer - Professioneel Vastgoedbeheer"
        fallbackDescription="Croostenburght Beheer beheert en verhuurt hoogwaardige onroerend goed in Amsterdam, Rotterdam en Utrecht."
      />
      <Navigation />
      <main>
        <Hero />
        <CompanyIntro />
        <PropertyTeaser />
        <ProjectsTeaser />
        <ContactBanner />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
